module.exports = __webpack_public_path__ + "img/knu_gallery9.c042177e.jpg";